export { ProductCardLink } from './product-card-link'
export type { ProductCardLinkProps } from './product-card-link'
